class StateModel{
    stateId:number;
    name?: string;
    code?: string;
    
}
export default StateModel;